module.exports = __webpack_public_path__ + "static/media/sol-partitura.3abfdb7a.png";